<template>
  <div class="bar">
    <div class="logo">
      <router-link to="/">
      <img src="logo-30px-white.png">
      </router-link>
      <span class="subtitle d-none d-md-inline-block">
        قاموس متواردات لفظية
      </span>
    </div>
    <div class="search">
      <input value="بحث" v-model="query" @focus="query=''" @input="queryChanged()"/>
      <octicon name="search" flip="horizontal"/>
    </div>
    <user-status class="user"/>
  </div>
</template>

<script>
import Octicon from 'vue-octicon/components/Octicon.vue'
import 'vue-octicon/icons/search'

import UserStatus from './user-management/UserStatus.vue'

export default {
  name: 'Navbar',
  data: function () { return { query: '' } },
  components: {
    Octicon, UserStatus
  },
  methods: {
    queryChanged: function () {
      if (this.query) {
        this.$router.push(`/search/${this.query}`)
      } else {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style scoped>
  .bar {
    background-color:black;
    display: flex;
    width: 100%;
    color: white;
  }
  .logo {
    font-size: 20px;
    font-family: monospace;
    font-weight: bold;
    flex: 1 1 auto
  }
  .logo a {
    color: white
  }
  .logo .subtitle {
    font-weight: 100;
    font-size: 70%
  }
  .subtitle {
    margin-right: 10px
  }
  .search, .user {
    flex: 0 0 auto;
  }
  .logo, .search, .user {
    padding: 5px 10px
  }
  .user {
    background-color: #333333;
    color: #cccccc
  }
  .user >>> a:any-link {
    color: #cccccc
  }
  .user >>> a:hover {
    color: white
  }
  input {
    border: 0px;
    width: 150px;
    background: none;
    border-bottom: 1px solid grey;
    color: white
  }
</style>
